/* 🤖 this file was generated by svg-to-ts */
export const matIconPrintDisabled: {
  name: 'print-disabled';
  data: string;
} = {
  name: 'print-disabled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M1.41 1.6 0 3.01 5 8c-1.66 0-3 1.34-3 3v6h4v4h12l2.95 2.96 1.41-1.41L1.41 1.6zM6 15H4v-4c0-.55.45-1 1-1h2l3 3H6v2zm2 4v-4h4l4 4H8zM8 5h8v3h-5.34l2 2H19c.55 0 1 .45 1 1v4l-2 .01V13h-2.34l4 4H22v-6c0-1.66-1.34-3-3-3h-1V3H6v.36l2 2V5z"/><circle cx="18" cy="11.51" r="1"/></svg>`
};
